import { Link,useNavigate } from "react-router-dom";
import "./app-wide.css";

const Navbar = ({hideNav=false, isSignup=false, isLogin=false}) => {


  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const navigate = useNavigate();
  

  return (
    <nav className="nav-section">
      <div className="nav-section-inner">
        <div onClick={() => navigate("/")} className="nav-section-logo-container">
            <img onClick={() => navigate("/")} className="nav-section-logo" src="stockarchiveslogo2.png"/>
            <p onClick={() => navigate("/")} className="nav-section-logo-text">Stock Archives</p>
        </div>
        <div className="nav-section-links-container">
          {hideNav?null:<button onClick={() => navigate("/")} className="nav-section-links">Home</button>}
          {hideNav?null:<button onClick={() => scrollTo("about")} className="nav-section-links">About</button>}
          {hideNav?null:<button onClick={() => scrollTo("products")} className="nav-section-links">Products</button>}
          {hideNav?null:<button onClick={() => scrollTo("cost")} className="nav-section-links">Cost</button>}
          {hideNav?null:<button onClick={() => scrollTo("faq")} className="nav-section-links">FAQ</button>}
        </div>
        <div className="nav-section-login-signup-container">
          <Link to="/login?fromSignup=false" className={null/*isLogin?"nav-section-login-signup nav-login-button-active":"nav-section-login-signup"*/}><button className={isLogin?"nav-login-button-active":"nav-login-button"}>Login</button></Link>
          <Link to= "/login?fromSignup=true" className="nav-section-login-signup"><button className={isSignup?"nav-signup-button-active":"nav-signup-button"}>Sign Up</button></Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;